import React from 'react'
import { LocalStorageService, Auth0Service } from '../../../services'

class HomeAction extends React.Component {
    constructor(props) {
        super(props)
        this.props = props
    }
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()

    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
    }

    render() {
        return (
            <div>
                <h2>Registro Terminado - Bienvenido</h2>
                <a href="/" onClick={this.handleButtonLogOut}>Cerrar sesión</a>
            </div>
        )
    }
}
export { HomeAction as default }